// import { CloudCog } from "lucide-react";
import React, { useState } from "react";



type PageHeaderMedia =
  | { type: "video"; src: string; poster?: string }
  | { type: "image"; src: string };

interface PageHeaderProps {
  title?: string;
  media?: PageHeaderMedia;
  onMediaLoad?: () => void;
}

const PageHeader = ({ title = "About Us", media, onMediaLoad }: PageHeaderProps) => {
  const [mediaLoaded, setMediaLoaded] = useState(false);

  // Handler for when image is loaded
  const handleMediaLoaded = () => {
    setMediaLoaded(true);
    if (onMediaLoad) onMediaLoad();
  };

  return (
    <div className="relative h-[500px] md:h-[858px] flex items-center   overflow-hidden">
      {/* Static gray placeholder until media is loaded */}
      {!mediaLoaded && (
        <div
          className="absolute top-0 left-0 w-full h-full z-0 bg-gray-200 animate-none"
          style={{ minHeight: "500px", minWidth: "100%" }}
        />
      )}
      {/* Background Media */}
      { media?.type === "image" ? (
        <img
          className="absolute top-0 left-0 w-full h-full object-cover z-0 scale-105 md:scale-110 transition-transform duration-700"
          src={media.src}
          alt={title}
          style={{ objectFit: "cover" }}
          onLoad={handleMediaLoaded}
        />
      ) : null}
 
      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full  z-10" />
      {/* Title */}
   <h1
  className="
    font-utility           /* your Utility Pro family */
    font-medium  
    mx-auto
    md:mx-auto
    -bottom-[50px] /* 50px from the bottom on small screens */
    md:-bottom-[74px]
    text-[40px]             /* weight 500 */
    md:text-[100px]           /* exactly 100px size */
    leading-[120%]         /* 120% line-height */
    tracking-[-1%]         /* –1% letter-spacing */
    relative z-20 text-white
    px-[30px]
    md:px-0
    whitespace-pre-line    /* honor the \n in your string */
  "
>
  {title}
</h1>
    </div>
  );
};

export default PageHeader;
